import { DELETE, GET, PATCH, POST } from "../axios/apiService";
import { apiEnv } from "../axios/constant";

const telephonySlug = apiEnv === "beta" ? "telephony-beta" : "telephony";
const sonicSlug = apiEnv === "beta" ? "sonic-beta" : "sonic";
const tedLassoSlug = apiEnv === "beta" ? "tedlasso-beta" : "tedlasso";
export const getCallsList = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${telephonySlug}/recordings${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCallMetadata = async ({ callId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${telephonySlug}/recordings/${callId}`;
  return GET(url, options);
};

export const getCallDetails = async ({ callId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${sonicSlug}/api/v1/analysis/recording/${callId}`;
  return GET(url, options);
};

export const getCoachBots = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/get-bots`;
  return GET(url, options);
};

export const getCoachAIToken = async ({ options, botId }) => {
  const searchParams = botId ? `?bot_id=${encodeURIComponent(botId)}` : "";
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/getToken${searchParams}`;
  return GET(url, options);
};
export const coachAICreateBot = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/create-bot`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};
export const coachAIGenerateCallReport = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/bot/generate-reports`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};
export const deleteCoachAIBot = async ({ botId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/delete-bot/${botId}`;
  return DELETE(url, {
    withCredentials: false,
    ...options,
  });
};
export const coachAIhandshake = async ({ data, options }) => {
  const url = `https://api.openai.com/v1/realtime?model=gpt-4o-realtime-preview-2024-12-17`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const getCoachAICallHistory = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/bot/call-history${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCoachAICallReport = async ({ sessionId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${tedLassoSlug}/api/v1/bot/call-report?session_id=${encodeURIComponent(sessionId)}`;
  return GET(url, options);
};
